import { MigrationResourcesCard } from "../../cards/migration-resources-card";
import { RequestSupportCard } from "../../cards/request-support-card";
import { BaseRelationshipsSection } from "../base-relationships-section";

export const NoRelationshipsSection = () => {
    return (
        <BaseRelationshipsSection>
            <RequestSupportCard />
            <MigrationResourcesCard />
        </BaseRelationshipsSection>
    );
};
